/* Progressive image reveal: every <img> blurs/fades in once it has actually loaded.
   The html.zk-imgfx flag is set inline in the <head> (so the CSS only applies when JS
   runs); this script marks images as loaded and watches for injected ones (search,
   recommendations, cart). The hero still (LCP) and header are excluded. */
(function () {
  if (!document.documentElement.classList.contains('zk-imgfx')) return;
  function mark(img) {
    if (img.complete && img.naturalWidth > 0) { img.classList.add('is-loaded'); return; }
    var done = function () { img.classList.add('is-loaded'); };
    img.addEventListener('load', done, { once: true });
    img.addEventListener('error', done, { once: true });
  }
  function eligible(img) {
    // Images that manage their own opacity/transform: knife card hover photo, the rotating
    // knife line art and the PDP profile cut-out
    // (rotated 90° into a strip on mobile; the reveal's transform would swing it back upright)
    if (img.classList.contains('zk-knives__card-bg') || img.classList.contains('zk-knives__art-img') || img.classList.contains('zk-mp-profile__img')) return false;
    // LCP candidates (eager / high priority hero photos) must paint the moment they arrive:
    // hiding them until this deferred script runs added ~4s of render delay in Lighthouse.
    if (img.loading === 'eager' || img.getAttribute('fetchpriority') === 'high') return false;
    return !img.closest('.zk-hero, .zk-chero, .zk-header, .zk-kyk__profile, .shopify-section-group-header-group');
  }
  function scan(root) {
    var list = root.querySelectorAll ? root.querySelectorAll('img:not(.zk-fx)') : [];
    Array.prototype.forEach.call(list, function (img) { if (eligible(img)) { img.classList.add('zk-fx'); mark(img); } });
  }
  scan(document);
  if ('MutationObserver' in window) {
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        Array.prototype.forEach.call(m.addedNodes, function (n) {
          if (n.nodeType !== 1) return;
          if (n.tagName === 'IMG') { if (eligible(n)) { n.classList.add('zk-fx'); mark(n); } }
          else scan(n);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
